<div class="page-header ">
  <div class="flex xl:align-items-center flex-wrap xl:flex-nowrap gap-3">
    <div class="flex-grow-1">
      <!-- <app-primeng-breadcrumb></app-primeng-breadcrumb> -->
    </div>

    <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-end"></div>

  </div>

</div>

<div class="page-content">

  <div class="card card-body">
    <form #f="ngForm" autocomplete="off">
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-3 form-group">
          <p-card class="card-border">
            @if(loading()){
            <app-skeleton id="label-input-items"></app-skeleton>
            }@else{
            <label for="">Resource Name</label>
            <h3 class="m-0">{{applicationData.info.resourceName}}</h3>
            }
          </p-card>
        </div>
        <div class="col-12 md:col-6 lg:col-3 form-group">
          <p-card class="card-border">
            @if(loading()){
            <app-skeleton id="label-input-items"></app-skeleton>
            }@else{
            <label for="">Resource Type</label>
            <h3 class="m-0">{{applicationData.type}}</h3>
            }
          </p-card>

        </div>
        <div class="col-12 md:col-6 lg:col-3 form-group">
          <p-card class="card-border">
            @if(loading()){
            <app-skeleton id="label-input-items"></app-skeleton>
            }@else{
            <label for="">Date Created</label>
            <h3 class="m-0">{{ applicationData.info.createdTs | customDatePipe }}</h3>
            }
          </p-card>

        </div>
        <div class="col-12 md:col-6 lg:col-3 form-group">
          <p-card class="card-border">
            @if(loading()){
            <app-skeleton id="label-input-items"></app-skeleton>
            }@else{
            <label for="">Application Name</label>
            <h3 class="m-0">{{applicationData.info.applicationName}}</h3>
            }
          </p-card>

        </div>
      </div>
      @if(loading()){
      <app-skeleton id="form-fields" [size]="{width:'15rem',height:'2rem'}"></app-skeleton>
      }
      <div class="m-3">
        <h2 class="mb-4" *ngIf="!loading()">Assign Resource</h2>
        @if(loading()){
        <app-skeleton *ngIf="loading()" id="tabs"></app-skeleton>
        <app-skeleton id="form-fields" [size]="{width:'15rem',height:'1.5rem'}"></app-skeleton>
        <div class="flex gap-3 mb-4">
          @for (i of [1,2]; track i){
          <app-skeleton id="form-fields" [size]="{width:'1.5rem',height:'1.5rem'}"></app-skeleton>
          <app-skeleton id="form-fields" [size]="{width:'3rem',height:'1rem'}"></app-skeleton>
          }
        </div>
        <div class="justify-end flex gap-3">
          @if(loading()){
          @for (i of [1,2]; track i){
          <app-skeleton id="form-fields" [size]="{width:'4rem',height:'2rem'}"></app-skeleton>
          }
          }
        </div>
        }@else{

        }

        <p-tabs *ngIf="!loading()">
          <p-tablist>
            @if(isSuperAdmin) {
            <p-tab value="organizations">Organizations</p-tab>
            }
            <p-tab value="roles">Roles</p-tab>
          </p-tablist>
          <p-tabpanels>
            @if(isSuperAdmin) {
            <p-tabpanel value="organizations">
              <div class="grid" *ngIf="!isCustomer">
                <div class="col-12 md:col-6 xl:col-3 mb-4">
                  <p-multiSelect [options]="customerTableData" [filter]="true" onClear="clearCustomerOptions()"
                    (onChange)="onCustomerSelect($event.value)" optionLabel="customerName" display="chip"
                    [showClear]="true" placeholder="Search Organizations" />
                </div>
              </div>
              <div class="grid">
                <div class="col-6 md:col-4 lg:col-3" *ngFor="let cust of customerTableDataCopy ; let i = index">
                  <ng-container *ngIf="!isUserCustomerServiceExecutive">
                      <p-checkbox [(ngModel)]="cust.assigned" [name]="cust.customerName + i"
                      [inputId]="buildLabel(i)" [binary]="true"  [ariaLabel]="cust?.customerName"
                      (onChange)="toggleCustomerResourceAllocationMap(cust.customerId)" />
                  </ng-container>
                </div>
              </div>
              <div class="flex justify-content-end gap-3 mt-4">
                <button type="button" severity="secondary" pButton (click)="navigateToApplicationsList()">Back
                </button>
                <button type="button" severity="primary" pButton *ngIf="!isUserCustomerServiceExecutive"
                  (click)="submitCustomers()" [disabled]="!isCustomerSubmitButtonEnabled || isDisabled">Update
                </button>
              </div>
            </p-tabpanel>
            }
            <p-tabpanel value="roles">
              <div class="grid">
                <div class="col-12 md:col-6 xl:col-3 mb-4">
                  <p-multiSelect [options]="rolesTableData" [filter]="true" onClear="clearRoleOptions()"
                    (onChange)="onRoleSelect($event.value)" optionLabel="roleName" display="chip" [showClear]="true"
                    placeholder="Search Roles" />
                </div>
              </div>
              <div class="grid gap-2">
                @if(loading()){
                <app-skeleton id="form-fields" [size]="{width:'1.5rem',height:'1.5rem'}"></app-skeleton>
                <app-skeleton id="form-fields" [size]="{width:'3rem',height:'1rem'}"></app-skeleton>
                }@else{
                <div class="col-6 md:col-4 lg:col-3" *ngFor="let role of rolesTableDataCopy; let i = index">
                  <ng-container *ngIf="!isUserCustomerServiceExecutive">
                  <p-checkbox [(ngModel)]="role.isAssigned" [name]="role.roleName + i"
                      [inputId]="buildLabel(i)" [binary]="true"  [ariaLabel]="role?.roleName"
                      (onChange)="toggleRoleResourceAllocationMap(role.roleId)" />
                  </ng-container>
                </div>
                }
              </div>
              <div class="flex justify-content-end gap-3 mt-4">
                <button type="button" pButton severity="secondary" (click)="navigateToApplicationsList()">Back
                </button>
                <button type="button" pButton severity="primary" *ngIf="!isUserCustomerServiceExecutive"
                  (click)="submitRoles()" [disabled]="!isRoleSubmitButtonEnabled  || isDisabled">
                  Update
                </button>
              </div>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </form>
  </div>
</div>
<p-toast />